<script setup lang="ts">
import {
    LazyContentCookiePolicyCs,
    LazyContentCookiePolicyDe,
    LazyContentCookiePolicyEn,
    LazyContentCookiePolicyEs,
    LazyContentCookiePolicyFr,
    LazyContentCookiePolicyIt,
    LazyContentCookiePolicyNl,
    LazyContentCookiePolicyPl,
    LazyContentCookiePolicyPt,
    LazyContentCookiePolicyRo,
    LazyContentCookiePolicyRu,
} from '#components';
import { Locale } from '~i18n/i18nConfig';

// COMPOSABLES
const { locale, tt } = useTypedI18n();
useSeoMeta({
    title: tt('seo.cookiePolicy.title'),
    ogTitle: tt('seo.cookiePolicy.title'),
    description: tt('seo.cookiePolicy.description'),
    ogDescription: tt('seo.cookiePolicy.description'),
});

const currentComponent = computed<Component>(() => {
    const componentByLocale: Record<Locale, Component> = {
        [Locale.CS]: LazyContentCookiePolicyCs,
        [Locale.DE]: LazyContentCookiePolicyDe,
        [Locale.EN]: LazyContentCookiePolicyEn,
        [Locale.ES]: LazyContentCookiePolicyEs,
        [Locale.FR]: LazyContentCookiePolicyFr,
        [Locale.IT]: LazyContentCookiePolicyIt,
        [Locale.NL]: LazyContentCookiePolicyNl,
        [Locale.PL]: LazyContentCookiePolicyPl,
        [Locale.PT]: LazyContentCookiePolicyPt,
        [Locale.RO]: LazyContentCookiePolicyRo,
        [Locale.RU]: LazyContentCookiePolicyRu,
    };

    return componentByLocale[locale.value];
});
</script>

<template>
    <div>
        <component :is="currentComponent" />
    </div>
</template>
